import React from 'react'
import PropTypes from 'prop-types'

import { Label, Image, Modal } from 'semantic-ui-react'

import Container from './PreviewModalHomeContainer'

import Button from 'Components/StandardButton'
import KeyboardNavigation from 'Components/PreviewModal/KeyboardNavigation'
import PreviewModalImage from 'Components/PreviewModal/PreviewModalImage'
import PreviewModalMeta from 'Components/PreviewModal/PreviewModalMeta'

import { THEME_COLOR } from 'Global/constants'

const PreviewModalHome = props => (
  <Modal basic={props.expanded} onClose={props.toggle} open={props.open} size="small">
    <KeyboardNavigation handleKeyDown={props.handleKeyDown}>
      {!props.expanded ? (
        <KeyboardNavigation handleKeyDown={props.handleKeyDown}>
          <Modal.Header>Preview</Modal.Header>
        </KeyboardNavigation>
      ) : null}

      <Modal.Content>
        <KeyboardNavigation handleKeyDown={props.handleKeyDown}>
          <PreviewModalImage
            handleClickLeft={props.handleClickLeft}
            handleClickRight={props.handleClickRight}
            next={props.next}
            previous={props.previous}
          >
            {props.currentPicture && (
              <Image
                label={
                  <Label
                    as="a"
                    color={THEME_COLOR}
                    corner="left"
                    icon={props.basic ? 'compress' : 'expand arrows alternate'}
                    onClick={props.toggleExpansion}
                  />
                }
                src={props.currentPicture}
                fluid
              />
            )}
          </PreviewModalImage>

          {!props.disableRugInformation ? (
            <KeyboardNavigation handleKeyDown={props.handleKeyDown}>
              <PreviewModalMeta>{`${props.currentRug.id} | ${props.currentRug.name}`}</PreviewModalMeta>
            </KeyboardNavigation>
          ) : null}
        </KeyboardNavigation>
      </Modal.Content>

      {!props.expanded ? (
        <Modal.Actions>
          <KeyboardNavigation handleKeyDown={props.handleKeyDown}>
            <Button content="Close" error={props.error} icon={'x'} loading={props.pending} onClick={props.toggle} />
          </KeyboardNavigation>
        </Modal.Actions>
      ) : null}
    </KeyboardNavigation>
  </Modal>
)

PreviewModalHome.propTypes = {
  expanded: PropTypes.bool,
  basic: PropTypes.bool,
  error: PropTypes.bool,
  pending: PropTypes.bool,
  currentPicture: PropTypes.string.isRequired,
  currentRug: PropTypes.object.isRequired,
  disableRugInformation: PropTypes.bool.isRequired,
  handleClickLeft: PropTypes.func.isRequired,
  handleClickRight: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  lightBackground: PropTypes.bool,
  next: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  previous: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  toggleExpansion: PropTypes.func.isRequired,
}

PreviewModalHome.defaultProps = {
  basic: false,
  error: false,
  expanded: false,
  lightBackground: false,
  pending: false,
}

export default Container(PreviewModalHome)
